var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPinMsgInbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---chating---Menu-Copy-2",
    transform: "translate(-29.000000, -456.000000)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(21.000000, 17.150000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85770308,16.9787353 L0,21.8242941",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.167507003,12.4024021 L9.63878306,21.85 C11.652566,19.8412515 12.1202834,16.8605279 11.0159508,14.398191 L17.4210798,8.00907473 C19.0321062,8.43674377 20.8120305,8.03499407 22.0722689,6.77790629 L15.2773754,0 C14.0301292,1.24412811 13.6143804,3.01960261 14.0301292,4.61364176 L7.61200793,11.0157177 C5.14349977,9.92710558 2.16829783,10.3936536 0.167507003,12.4024021 Z",
    id: "Stroke-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinMsgInbox);
export default __webpack_public_path__ + "static/media/icPinMsgInbox.d9f3c61eed0b6d09e03db8a4240441ac.svg";
export { ForwardRef as ReactComponent };